import React from 'react';

import {ABOUT_URL} from '../../config/urls';
import {BLOG_URL} from '../../config/urls';
import {CONSULTING_FORM_URL} from '../../config/urls';
import {useMediaQuery} from '../../hooks/useMediaQuery';
import {useMovePage} from '../../hooks/useMovePage';
import openNewWindow from '../../utils/openNewWindow';

import Button from '../common/Button';
import Dropdown from '../common/Dropdown';
import styles from './styles/menu-modal.module.css';

export default function MenuModal() {
    const movePage = useMovePage();

    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');

    return (
        <div className={styles.wrapper}>
            <Dropdown />
            <Button
                text='회사 소개'
                width='fit-content'
                height='29px'
                padding='0'
                backgroundColor='#FFF'
                border='none'
                borderRadius='none'
                fontSize='24px'
                fontWeight='600'
                textColor='#000'
                onClick={() => movePage('about')}
                style={{ justifyContent: 'flex-start' }}
            />
            <Button
                text='도입 사례'
                width='fit-content'
                height='29px'
                padding='0'
                backgroundColor='#FFF'
                border='none'
                borderRadius='none'
                fontSize='24px'
                fontWeight='600'
                textColor='#000'
                onClick={() => openNewWindow(BLOG_URL)}
            />
            <div className={styles.boxBtn}>
                <Button 
                    text='소개서 보기'
                    width={mobileMedium ? '356px' : '160px'}
                    height={mobileMedium ? '40px' : '38px'}
                    padding='8px 20px'
                    backgroundColor='#B7B6C0'
                    border='none'
                    borderRadius='7px'
                    fontSize='16px'
                    fontWeight='700'
                    textColor='#FFF'
                    onClick={() => openNewWindow(ABOUT_URL)}
                />
                <Button
                    text='컨설팅 신청'
                    width={mobileMedium ? '356px' : '160px'}
                    height={mobileMedium ? '40px' : '38px'}
                    padding='8px 20px'
                    backgroundColor='#825DFC'
                    border='none'
                    borderRadius='7px'
                    fontSize='16px'
                    fontWeight='700'
                    textColor='#FFF'
                    onClick={() => openNewWindow(CONSULTING_FORM_URL)}
                />
            </div>
        </div>
    );
}
